import script from "./InputBuscar.vue?vue&type=script&setup=true&lang=js"
export * from "./InputBuscar.vue?vue&type=script&setup=true&lang=js"

import "./InputBuscar.vue?vue&type=style&index=0&id=f12c4e72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f12c4e72"]])

export default __exports__